import React from "react";
import { useLocale } from "@insightfulscience/smart-react/i18";
import PageMeta from "@insightfulscience/smart-react/PageMeta";
import SimpleTemplate from "@insightfulscience/atomic-react/SimpleTemplate";
import SimpleTemplateTitle from "@insightfulscience/atomic-react/SimpleTemplate/Title";
import SimpleTemplateDescription from "@insightfulscience/atomic-react/SimpleTemplate/Description";
import Html from "@insightfulscience/smart-react/Html";
import pipe from "@insightfulscience/shared-utils/fn/pipe";
import propsResolver from "@insightfulscience/shared-utils/fn/props-resolver";
import FreeTrialBiologicsForm from "../../FreeTrialBiologicsForm";
import WithServices from "../../services";
import getCountriesProvider from "../../services/countryService/index";
import SiteLayout from "../../SiteLayout";

const FreeTrialBiologics = () => {
	const [t] = useLocale("free-trial-biologics");
	return (
		<SiteLayout>
			<PageMeta title={t("META.TITLE")} description={t("META.DESCRIPTION")}>
				<PageMeta.OGP
					locale={t("META.LOCALE")}
					type={t("META.TYPE")}
					title={t("META.TITLE")}
					description={t("META.DESCRIPTION")}
					url={t("META.URL")}
					siteName={t("META.SITE_NAME")}
					articlePublisher={t("META.ARTICLE_PUBLISHER")}
					image={t("META.IMAGE")}
					isImageBaseUrl
				/>
				<PageMeta.Canonical href={t("META.CANONICAL")} />
				<PageMeta.Twitter
					card={t("META.TWITTER_CARD")}
					title={t("META.TITLE")}
					description={t("META.DESCRIPTION")}
					site={t("META.TWITTER_SITE")}
					creator={t("META.TWITTER_CREATOR")}
				/>
			</PageMeta>

			<SimpleTemplate utility={{ bgColor: 4 }}>
				<SimpleTemplateTitle>{t("FORM_TITLE")}</SimpleTemplateTitle>
				<SimpleTemplateDescription>
					<Html Tag="span">{t("FORM_DESCRIPTION")}</Html>
				</SimpleTemplateDescription>
				<FreeTrialBiologicsForm />
			</SimpleTemplate>
		</SiteLayout>
	);
};

FreeTrialBiologics.services = {
	getCountries: getCountriesProvider,
};

FreeTrialBiologics.getInitialProps = propsResolver({
	countries: (_, { getCountries }) => getCountries(),
});

export default pipe(FreeTrialBiologics, WithServices);
